import "./styles.css";
import {
  BrowserRouter as Router,
  Route,
  Switch
} from "react-router-dom";
import ContextAppProvider from "./ContextAPI";
import React from "react";
import Body from "./Website/Body/Body";
import Notifisystem from "./Notifications/Notifisystem";
import { ScrollToTop } from "./ScrollToTop";

export default function App() {
  return (
    <Router>
      <ContextAppProvider>
        <a href="#main-content" className="skip-link">Skip to main content</a>
        <Notifisystem />
        <ScrollToTop />
        <Switch>
          <Route>
            <Body />
          </Route>
        </Switch>
      </ContextAppProvider>
    </Router>
  );
}
 